import { SocialMediaPostPreviewController } from './social-media-post-preview.controller'

function socialMediaPostPreview () {
  return {
    restrict: 'E',
    controller: SocialMediaPostPreviewController,
    templateUrl: '/arts/directives/social-media-post-preview/social-media-post-preview.html?$$REVISION$$',
    scope: {
      format: '<',
      template: '<',
      previewUrl: '<',
      loading: '<',
      selectedMaterial: '<'
    }
  }
}

export { socialMediaPostPreview }
